// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_pageWrapper__AaZIy","pageTitle":"PageWrapper_pageTitle__d3tkw","slideUp":"PageWrapper_slideUp__Typtd","page--title":"PageWrapper_page--title__BIq-o"};